import RegistrationForm from "./registrationForm.js";
import AuthTravelShell from "../../components/travel-theme/AuthTravelShell.js";

const Register = () => {
  return (
    <AuthTravelShell
      eyebrow="HackPrinceton registration"
      title="Book your seat."
      description="Create your account, verify your email address, and begin your application for HackPrinceton Fall 2026."
      ticketCode="SIGN UP"
    >
      <RegistrationForm />
    </AuthTravelShell>
  );
};

export default Register;
